(function () {
  angular.module("akitabox.ui.components.dateInput", [
    "akitabox.core.lib.moment",
    "akitabox.core.utils",
    "ngMaterial",
  ]);
})();
